import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import TradingPage from "../pages/trading/page";
import ProcurementPage from "../pages/procurement/page";
import LogisticsPage from "../pages/logistics/page";
import FreightForwardingPage from "../pages/freight-forwarding/page";
import ClearingForwardingPage from "../pages/clearing-forwarding/page";
import Products from "../pages/products/page";
import ProductDetail from "../pages/product-detail/page";
import Industries from "../pages/industries/page";
import Contact from "../pages/contact/page";
import FAQ from "../pages/faq/page";
import News from "../pages/news/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminDashboardPage from "../pages/admin/dashboard/page";
import AdminProductsPage from "../pages/admin/products/page";
import AdminInquiriesPage from "../pages/admin/inquiries/page";
import AdminArticlesPage from "../pages/admin/articles/page";
import AdminSettingsPage from "../pages/admin/settings/page";
import AdminManufacturerDocsPage from "../pages/admin/manufacturer-docs/page";
import { AuthGuard } from "../lib/auth";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/trading",
    element: <TradingPage />,
  },
  {
    path: "/procurement",
    element: <ProcurementPage />,
  },
  {
    path: "/logistics",
    element: <LogisticsPage />,
  },
  {
    path: "/freight-forwarding",
    element: <FreightForwardingPage />,
  },
  {
    path: "/clearing-forwarding",
    element: <ClearingForwardingPage />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/products/:id",
    element: <ProductDetail />,
  },
  {
    path: "/industries",
    element: <Industries />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AuthGuard><AdminDashboardPage /></AuthGuard>,
  },
  {
    path: "/admin/products",
    element: <AuthGuard><AdminProductsPage /></AuthGuard>,
  },
  {
    path: "/admin/inquiries",
    element: <AuthGuard><AdminInquiriesPage /></AuthGuard>,
  },
  {
    path: "/admin/articles",
    element: <AuthGuard><AdminArticlesPage /></AuthGuard>,
  },
  {
    path: "/admin/settings",
    element: <AuthGuard><AdminSettingsPage /></AuthGuard>,
  },
  {
    path: "/admin/manufacturer-docs",
    element: <AuthGuard><AdminManufacturerDocsPage /></AuthGuard>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;